import React from 'react';

import WidgetNewportAppSettingsEditor from 'widgets/WidgetSettingsEditing/WidgetNewportAppSettingsEditor';
import { useWidgetConfigUpdater } from 'widgets/WidgetSettingsEditing/useWidgetConfigUpdater';

import { useVenueExecCapsuleConfigSlice } from 'widgets/venueAnalysis/capsules/venueExecCapsule/store/config/configslice';
import WidgetSettingsCheckboxValueEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsCheckboxValueEditor';
import { VenueAnalysisCapsuleConfigState } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';
import { CapsuleSettingsSymbolEditor } from 'widgets/tiles/components/tile/CapsuleSettingsSymbolEditor';

export const VenueExecCapsuleSettingsText = `Fills by Venue Capsule Settings`;

export interface VenueExecCapsuleSettingsProps {
    config?: VenueAnalysisCapsuleConfigState;
    onChange?: (nextDelta: Partial<VenueAnalysisCapsuleConfigState>) => void;
}

export default function VenueExecCapsuleSettings(
    props: VenueExecCapsuleSettingsProps
) {
    const { onChange, config: propsConfig } = props;
    const { config: configSliceConfig, dispatchConfigChanged } =
        useVenueExecCapsuleConfigSlice();

    const { debouncedApplyWidgetConfigChange } = useWidgetConfigUpdater(
        dispatchConfigChanged,
        onChange
    );
    const config = propsConfig ?? configSliceConfig;

    return (
        <div className="VenueExecCapsuleSettings">
            <div className="group ">
                <CapsuleSettingsSymbolEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />
            </div>

            <WidgetSettingsCheckboxValueEditor
                propertyName="includePreviousDaysFills"
                config={config!}
                label="Show portion of order filled in previous days' trading"
                onChange={debouncedApplyWidgetConfigChange}
            />

            <WidgetNewportAppSettingsEditor />
        </div>
    );
}
